import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'agl-agenda',
  templateUrl: './agenda.component.html',
  styleUrls: ['./agenda.component.scss']
})
export class AgendaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
